
export default class ToggleFilter {
	constructor(el) {

		this.toggle 		= el
		this.clickToggle 	= this.clickToggle.bind(this)
		this.toggleButtons 	= [...this.toggle.querySelectorAll(".toggle__btn") ];
		this.allFilters 	= document.querySelectorAll("[data-filter]")
		this.allTabs 		= document.querySelectorAll("[data-filtercat]")

	}
  
	init() {
		for (var i = 0; i < this.toggleButtons.length; i++) {
			this.toggleButtons[i].addEventListener('click', this.clickToggle )
		}
	}
  
	clickToggle(event) {

		const inx = this.toggleButtons.indexOf(event.currentTarget)
		const button = this.toggleButtons[inx]
		let tabs = null

		if( button.dataset.filter === 'all' ){
			tabs = document.querySelectorAll(`[data-filtercat]`)
		} else {
			tabs = document.querySelectorAll(`[data-filtercat="${button.dataset.filter}"]`)
			console.log('here')
		}

		if(button.classList.contains('toggle__btn--active')){
			return
		}

		// UPDATE BUTTON STATE
		button.classList.toggle('toggle__btn--active')
		this.toggle.style.setProperty('--distance', inx)

		if( button.ariaExpanded === 'false' ){
			button.setAttribute('aria-expanded', 'true');
		} else {
			button.setAttribute('aria-expanded', 'false');
		}

		// UPDATE FILTERS
		this.allTabs.forEach(tab => {
			tab.classList.add('hide')
		});

		console.log(tabs)
		
		tabs && tabs.forEach(tab => {
			tab.classList.remove('hide')
			console.log(tab.ariaExpanded)
			console.log(this.allTabs)
			this.closeSiblingToggles(tab,this.allTabs)
		});

		this.closeSiblingToggles(button,this.toggleButtons)

	}

	openTab(tab) {

		if( tab.ariaExpanded === 'false' ){
			tab.setAttribute('aria-expanded', 'true')
		} else {
			tab.setAttribute('aria-expanded', 'false')
		}
	}

	closeSiblingToggles(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove('toggle__btn--active');

				// JUST FOR TABS
				if( siblings[i].ariaExpanded === 'false' ){
					siblings[i].setAttribute('aria-expanded', 'true');
				} else {
					siblings[i].setAttribute('aria-expanded', 'false');
				}
			}
		}
	}
  
}
